import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Internship } from '../../models/internship';
import { CompanyService } from '../../service/company.service';
import { AddInternshipDialogComponent } from '../add-internship-dialog/add-internship-dialog.component';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatAccordion } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-edit-internship-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatIcon, MatAccordion, MatButtonModule, TranslateModule],
  templateUrl: './edit-internship-dialog.component.html',
  styleUrl: './edit-internship-dialog.component.css'
})

export class EditInternshipDialogComponent {

  constructor(private dialogRef: MatDialogRef<EditInternshipDialogComponent>, private companyService: CompanyService,
      @Inject(MAT_DIALOG_DATA) public internshipData: Internship, private dialog: MatDialog,
      private translate: TranslateService

  ) {}

  updateInternship(): void {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: this.translate.instant('internship-dialog.confirm-save') }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){
        if (!this.internshipData.id) {
          console.error('ID del tirocinante mancante');
          return;
        }
        
        this.companyService.updateInternship(this.internshipData.id, this.internshipData).subscribe({
          next: (res) => {
            console.log('Tirocinante aggiornato con successo:', res);
            this.dialogRef.close(true);
          },
          error: (err) => {
            console.error('Errore durante aggiornamento:', err);
            alert(this.translate.instant('internship-dialog.errors.update'));
          }
        });
      }
    });
  }

    onCancel(): void {
    this.dialogRef.close();
  }

  
   step = signal(0);

  setStep(index: number) {
    this.step.set(index);
  }

  nextStep() {
    this.step.update(i => i + 1);
  }

  prevStep() {
    this.step.update(i => i - 1);
  }

}
